import loadable from "@loadable/component";
import { fetchRegionalPrices } from "../features/regionalPrices/regionalPricesSlice";

const AppPage = loadable(() => import("./AppPage.page"));

const loadData = (store) => {
  const { localization: { data } } = store.getState();
  const actions = [fetchRegionalPrices(data)];
  return Promise.all(actions.map((action) => store.dispatch(action)));
};

export default { component: AppPage, loadData };
